<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词"
            />
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-date-picker
              v-model="queryForm.startTime"
              type="datetime"
              placeholder="开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.endTime"
              type="datetime"
              placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
            <el-button icon="el-icon-download" type="warning" :loading="exportLoading" @click="exportData">
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="评价人"
        prop="basic.profile.avatar"
        width="80"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-avatar shape="square" :size="32" :src="row.basic.profile.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="评价人昵称"
        prop="basic.profile.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="设备标题"
        prop="basic.deviceTitle"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="评价标题"
        prop="basic.rankTitle"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="星级"
        prop="basic.starIndex"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="星级描述"
        prop="basic.star"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="评价时间"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
                <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleShow(row)">
            详情
          </el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-if="row.step != 2" :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <record-detail ref="show" />
  </div>
</template>

<script>
import moment from 'moment'
import { findRankRecordList, removeRankRecord, exportRankRecord, } from '@/api/alfmeier'
import RecordDetail from './recordDetail.vue'
export default {
  name: 'AlfmeierRankRecordList',
  components: { RecordDetail },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      exportLoading: false,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        startTime: '',
        endTime: '',
        keyword: ''
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/alfmeier/rankRecordList') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    //获取餐厅列表
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    handleDelete(row) {
      this.$baseConfirm(`你确定要删除评价记录：${row.basic.profile.name} ${row.basic.rankTitle} 吗`, null, async () => {
        await removeRankRecord({ rankRecordId: row.rankRecordId })
        this.$baseMessage(
          `删除评价记录成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.queryData()
      })
    },
    handleCommand(command) {
      switch (command.cmd) {
        case 'delete':
          this.handleDelete(command.item)
          break
      }
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async exportData() {
      this.exportLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const ret = await exportRankRecord(data)
      this.exportLoading = false
      if(ret && ret.url){
        this.$alert(`下载地址：${ret.url}`, '评价记录导出', {
          confirmButtonText: '立即下载',
          callback: action => {
            window.location.href = ret.url
          }
        })
      }
    },
    async fetchData() {
      this.listLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const { list, total } = await findRankRecordList(data)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
